module.exports = __webpack_public_path__ + "img/terry-gallery-1.3039f43f.jpg";